import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { TreatDate } from '../util/treatDate';

declare var $ :any;

@Component({
  selector: 'app-erro-primeiroacesso',
  templateUrl: './erro-primeiroacesso.component.html',
  styleUrls: ['./erro-primeiroacesso.component.css']
})


export class ErroPrimeiroacessoComponent extends AbstractComponent implements OnInit  {
  public mensagem: string;
  dataCompleta: string;

  constructor(
    private router: Router,
    public sessaoService: SessaoService) {
    super(sessaoService);

    this.dataCompleta = TreatDate.getDataAtualCompleta();
  }

  ngOnInit() {
    // Resolucao
    var WindowsSize=function(){
      // Toggle menu abrir conforme a resolucao
      var h=$(window).height(),
          w=$(window).width();

      // Conteudo altura
      $(".pageFull").css('height', h);
    };
    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);

    this.mensagem = sessionStorage.getItem("mensagem_erro");
    if(!this.mensagem){
      this.router.navigate(['']);
    }
    sessionStorage.removeItem("mensagem_erro");

    // Parceiros
    if (this.sessaoService.sessao.autenticado.parceiro &&
      this.sessaoService.sessao.autenticado.parceiro.cdParceiro !== 1) {
      $( ".logoBradesco" ).attr( "style", "display: inline-block !important" );
    }
    $( ".imgLogin" ).attr( "src", "data:image/png;base64," + this.sessaoService.sessao.configuracaoVisual.imgLogoIdentificacao );
    $( ".imgLogin" ).attr( "title", this.sessaoService.sessao.configuracaoVisual.dsLogo );
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/erro-primeiroacesso/erro-primeiroacesso.component.ts